import api from './api';

export type BandwidthUrlRow = {
  url: string;
  count: number;
  totalBytes: number;
  avgBytes: number;
  maxBytes: number;
};

export type BandwidthIpRow = {
  ip: string;
  count: number;
  totalBytes: number;
};

export type BandwidthResponse = {
  minutes: number;
  file: string;
  error?: string;
  summary: {
    totalBytes: number;
    totalRequests: number;
    avgQps: number;
    windowSeconds: number;
    firstTs: number;
    lastTs: number;
  };
  topByBytes: BandwidthUrlRow[];
  topByCount: BandwidthUrlRow[];
  topIps: BandwidthIpRow[];
};

export type ConnectionSnapshot = {
  upstreamPort: number;
  tcpTotal: number;
  estab: number;
  closed: number;
  orphaned: number;
  timewait: number;
  toUpstream: number;
  topPeers: { ip: string; count: number }[];
  generatedAt: number;
};

export async function getBandwidth(params?: {
  minutes?: number;
  limit?: number;
  tailBytes?: number;
  method?: string;
}) {
  const res = await api.get<BandwidthResponse>('/admin/perf/bandwidth', { params });
  return res.data;
}

export async function getConnections() {
  const res = await api.get<ConnectionSnapshot>('/admin/perf/connections');
  return res.data;
}
